import { CallOptions, ClientMiddlewareCall } from 'nice-grpc-web';

import isDefined from '@/utils/isDefined';
import mergeDeep from '@/utils/mergeDeep';

type MiddlewareArgsType = {
  localeId?: string;
};

export function localeMiddleware({ localeId }: MiddlewareArgsType) {
  return async function* closedMiddleware<Request, Response>(
    call: ClientMiddlewareCall<Request, Response>,
    options: CallOptions,
  ) {
    const { request } = call;

    if (isDefined(localeId)) {
      Object.assign(request as any, {
        options: mergeDeep((request as any).options || {}, {
          localeId,
        }),
      });
    }

    const response = yield* call.next(call.request, options);

    return response;
  };
}
